import { useNavigate } from "react-router-dom";
import Header from "../components/Header";

function Videos() {
  const navigate = useNavigate();

  const videos = [
    {
      title: "Chaining Touch with This Way",
      link: "https://drive.google.com/file/d/113d6DhqEc4fZoxsGEu3wKkHc6PFeI9GZ/view?usp=sharing",
    },
    {
      title: "Ready, Steady, Go",
      link: "https://drive.google.com/file/d/1tDp2yuCcGMtku_mH7Y5_ZUqGM0Xt6THY/view?usp=sharing",
    },
    {
      title: "Reset Circle",
      link: "https://drive.google.com/file/d/1vgXBQNTqD5uasFTwyflJstNbPKmh2BP_/view?usp=sharing",
    },
    {
      title: "This Way",
      link: "https://drive.google.com/file/d/1N-pLvSeKlBI5WX5UwKhxHDIwdPFTw29W/view?usp=sharing",
    },
  ];

  return (
    <>
      <Header />
      <div className="min-h-screen bg-gray-50 p-8">
        <button
          onClick={() => navigate("/home")}
          className="mb-6 inline-flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 shadow-sm"
        >
          ← Back to Dashboard
        </button>

        <h1 className="text-4xl font-bold text-gray-800 mb-2">Video Library</h1>
        <p className="text-lg text-gray-600 mb-8">
          Real-time training demos to help you practise with confidence.
        </p>

        <h2 className="text-2xl font-semibold text-gray-700 mb-4">Training Videos</h2>

        <div className="grid sm:grid-cols-2 gap-4">
          {videos.map(({ title, link }) => (
            <a
              key={title}
              href={link}
              target="_blank"
              rel="noopener noreferrer"
              className="block p-4 bg-white border border-gray-200 rounded-lg text-blue-600 hover:border-blue-400 hover:shadow transition text-center font-medium"
            >
              {title}
            </a>
          ))}
        </div>
      </div>
    </>
  );
}

export default Videos;
